import cookies from 'js-cookie';
import settings from 'app/core/settings';
import { useDispatch } from 'react-redux';
import { updateTaskFromWS } from 'app/store/reducers/tasks';
import { createTakeFromWS, updateTakeFromWS } from 'app/store/reducers/takes';
import { useEffect, useRef } from 'react';
import { addLinkFromWS, updateAssetFromWS } from 'app/store/reducers/assets';
import { createAssetFlagsFromWS, deleteAssetFlagsFromWS } from 'app/store/reducers/reduxAssetFlags';
import { createAssetLinksFromWS, deleteAssetLinksFromWS } from 'app/store/reducers/reduxAssetLinks';
import { createTakeValidationMediasFromWS, deleteTakeValidationMediasFromWS, } from 'app/store/reducers/reduxTakeValidationMedias';
import { createTakeRefMediasFromWS, deleteTakeRefMediasFromWS } from 'app/store/reducers/reduxTakeRefMedias';
import { addFlagFromWS } from 'app/store/reducers/reduxFlags';
import { createDynamicApprovalValueFromWS, deleteDynamicApprovalValueFromWS, updateDynamicApprovalValueFromWS, } from 'app/store/reducers/reduxDynamicApprovalValues';
import { createPostBoardNoteFromWS, deletePostBoardNoteFromWS, updatePostBoardNoteFromWS, } from 'app/store/reducers/reduxPostBoardNotes';
import { addMediaFromWS } from 'app/store/reducers/reduxMedias';
const useWebsocket = () => {
    const dispatch = useDispatch();
    const token = cookies.get(settings.cookieToken);
    const wsUrl = settings.env.WS_URL;
    const connection = useRef({});
    const connect = (ws) => {
        ws.onopen = (event) => {
            console.log('Socket is open', event);
        };
    };
    useEffect(() => {
        const ws = new WebSocket(wsUrl, ['Authorization', token]);
        connect(ws);
        ws.onclose = (event) => {
            console.log('Socket is closed. Reconnect will be attempted in 1 second.', event.reason);
            setTimeout(() => {
                connect(ws);
            }, 1000);
        };
        ws.onmessage = (event) => {
            const data = JSON.parse(event.data);
            const { event: eventType, data: updatedData, model, timestamp } = data;
            if (eventType === 'message')
                return;
            const parsedData = JSON.parse(updatedData);
            switch (eventType) {
                case 'create':
                    const { flagInst, mediaInst, to_assetInst } = parsedData;
                    switch (model) {
                        case 'AssetFlags':
                            dispatch(addFlagFromWS(flagInst));
                            dispatch(createAssetFlagsFromWS(parsedData));
                            break;
                        case 'AssetLinks':
                            dispatch(addLinkFromWS(to_assetInst));
                            dispatch(createAssetLinksFromWS(parsedData));
                            break;
                        case 'DynamicApprovalValue':
                            dispatch(createDynamicApprovalValueFromWS(parsedData));
                            break;
                        case 'PostBoardNote':
                            dispatch(createPostBoardNoteFromWS(parsedData));
                            break;
                        case 'Take':
                            dispatch(createTakeFromWS(parsedData));
                            break;
                        case 'TakeValidationMedias':
                            dispatch(addMediaFromWS(mediaInst));
                            dispatch(createTakeValidationMediasFromWS(parsedData));
                            break;
                        case 'TakeRefMedias':
                            dispatch(addMediaFromWS(mediaInst));
                            dispatch(createTakeRefMediasFromWS(parsedData));
                            break;
                        default:
                            return;
                    }
                    break;
                case 'update':
                    switch (model) {
                        case 'Asset':
                            dispatch(updateAssetFromWS(parsedData));
                            break;
                        case 'DynamicApprovalValue':
                            dispatch(updateDynamicApprovalValueFromWS(parsedData));
                            break;
                        case 'PostBoardNote':
                            dispatch(updatePostBoardNoteFromWS(parsedData));
                            break;
                        case 'Task':
                            dispatch(updateTaskFromWS(parsedData));
                            break;
                        case 'Take':
                            dispatch(updateTakeFromWS(parsedData));
                            break;
                        default:
                            return;
                    }
                    break;
                case 'delete':
                    switch (model) {
                        case 'AssetFlags':
                            dispatch(deleteAssetFlagsFromWS(parsedData));
                            break;
                        case 'AssetLinks':
                            dispatch(deleteAssetLinksFromWS(parsedData));
                            break;
                        case 'DynamicApprovalValue':
                            dispatch(deleteDynamicApprovalValueFromWS(parsedData));
                            break;
                        case 'PostBoardNote':
                            dispatch(deletePostBoardNoteFromWS(parsedData));
                            break;
                        case 'TakeValidationMedias':
                            dispatch(deleteTakeValidationMediasFromWS(parsedData));
                            break;
                        case 'TakeRefMedias':
                            dispatch(deleteTakeRefMediasFromWS(parsedData));
                            break;
                        default:
                            return;
                    }
                    break;
                default:
                    return;
            }
            connection.current = ws;
        };
        return () => ws.close();
    }, []);
};
export default useWebsocket;
